import type React from "react";
import { Box } from "../Box/Box";
import { Text } from "../Text/Text";
import type { Color } from "../utils/colors";
import styles from "./Divider.module.css";

export interface DividerProps {
  color?: Color;
  text?: string;
}

export const Divider = ({
  color = "neutral-300",
  text,
}: DividerProps): React.ReactNode => {
  if (text) {
    return (
      <Box display="flex" alignItems="center">
        <Box flexGrow={1} className={[styles.base, styles[`color-${color}`]]} />
        <Box paddingX="2">
          <Text size="small" color={color}>
            {text}
          </Text>
        </Box>
        <Box flexGrow={1} className={[styles.base, styles[`color-${color}`]]} />
      </Box>
    );
  }

  return (
    <Box width="full" className={[styles.base, styles[`color-${color}`]]} />
  );
};
